import React, {useEffect, useState} from 'react';
import {useQuery} from 'react-query';
import CardsComponent from '../../common/cards';
import {GetCacheKey} from "../../../services/common/utils";
import Loadingcomponent from '../../loader/loadingcomponent';

function AllRoamingPacks({pmsitem}) {
    const [result, setResult]= useState({});
    const {
        data: {data}={},
        isSuccess,
        isLoading,
        isFetching
      }= useQuery([GetCacheKey('Roaming_countries_list'), pmsitem?.method, JSON.parse(pmsitem?.sourceid), {}])

    useEffect(()=>{
        if(isSuccess){
            const tempObj = {}
            data?.response?.map(item =>{
                if(!tempObj?.[item?.rnadditionalSubGroup]){
                    tempObj[item?.rnadditionalSubGroup] = [item]
                }else{
                    tempObj[item?.rnadditionalSubGroup] = [...tempObj[item?.rnadditionalSubGroup], item]
                }
            });
            setResult(tempObj);
        }
    }, [data])

  return (
        Object.keys(result)?.length === 0 ?  <Loadingcomponent/> :  Object.keys(result)?.map(item => (
            <div className='dls13_card_style2 mb-2 pse_sm'>
                <h6 className='pt-4'>{result[item]?.[0]?.additionalSubGroup}</h6>
                {result[item]?.map(obj => 
                    <CardsComponent type={38} data={obj} psmItem={pmsitem}/>
                )}
            </div>
            
        ))
  )
}

export default AllRoamingPacks;
